import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'
import { displayPortalDate, type MemberStatusSource } from './memberPortalPresentation'
import { MemberStatusSources } from './MemberStatusSources'

// Member access with no Membership of the person's own: from an organization's Roster or conferred.
export function MemberPortalConferredAccess({ sources }: { sources: MemberStatusSource[] }) {
  const rosterSources = sources.filter((source) => source.kind === 'organization_roster')
  return (
    <>
      {rosterSources.length ? (
        rosterSources.map((source) => (
          <MemberPortalOrganizationAccess
            key={`${source.organization_id}-${source.roster_place_id}`}
            source={source}
          />
        ))
      ) : (
        <ConferredMemberContent />
      )}
      <MemberStatusSources sources={sources} />
    </>
  )
}

function ConferredMemberContent() {
  return (
    <Card className="mt-6 p-4">
      <p className="text-body-sm font-medium">Member access</p>
      <p className="mt-1 text-caption text-muted-foreground">
        Your Association membership gives you access to member-only content.
      </p>
    </Card>
  )
}

// Membership for a person whose member access comes from an organization's Roster.
export function MemberPortalOrganizationAccess({ source }: { source: MemberStatusSource }) {
  const term =
    source.term_starts_on && source.renews_on
      ? `${displayPortalDate(source.term_starts_on)} – ${displayPortalDate(source.renews_on)}`
      : null
  return (
    <Card className="mt-6 overflow-hidden">
      <div className="flex items-center gap-2 p-4 pb-0">
        <p className="text-body font-medium">{source.level}</p>
        <Badge variant={source.status === 'Active' ? 'success' : 'neutral'}>{source.status}</Badge>
      </div>
      <dl className="space-y-1 p-4 text-body-sm">
        {term && (
          <div className="flex gap-2">
            <dt className="text-muted-foreground">Membership term</dt>
            <dd>{term}</dd>
          </div>
        )}
        {source.renews_on && (
          <div className="flex gap-2">
            <dt className="text-muted-foreground">Renewal due</dt>
            <dd>{displayPortalDate(source.renews_on)}</dd>
          </div>
        )}
      </dl>
      <p className="border-t border-border px-4 py-3 text-body-sm">
        Your member access comes through {source.label}.
      </p>
    </Card>
  )
}
